import {createSvgIcon} from '../create-svg-icon';

export const FastRewindIcon = createSvgIcon(
  <path d="M18 9.86v4.28L14.97 12 18 9.86m-9 0v4.28L5.97 12 9 9.86M20 6l-8.5 6 8.5 6V6zm-9 0-8.5 6 8.5 6V6z" />
, 'FastRewindOutlined');
